import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const BaseUrl = process.env.REACT_APP_API_URL;

// --- Thunks ---

export const NewAddMember = createAsyncThunk(
  "member/addMember",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/DynamicInHouseAccounts/iuyusadjhvfbcsamcbhjhdfh2345`,
        data
      );
      if (response?.data.status === "Customer add") {
        toast.success("Member added successfully!");
      } else {
        toast.error("Failed to add member. Please try again.");
      }
      return response.data;
    } catch (error) {
      toast.error("Something went wrong while adding member.");
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const UpdateMember = createAsyncThunk(
  "member/updateMember",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/DynamicInHouseAccounts/sdgdfgfd54575674sddfsd/${id}`,
        data
      );
      if (response?.data.status === "Customer updated") {
        toast.success("Member updated successfully!");
      } else {
        toast.error("Failed to update member. Please try again.");
      }
      return response.data;
    } catch (error) {
      toast.error("Something went wrong while updating member.");
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const toggleMemberStatus = createAsyncThunk(
  "member/toggleMemberStatus",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/DynamicInHouseAccounts/sdgdfgfd54575674ssssss/${id}`
      );
      if (response?.data.status === "Customer updated") {
        toast.success("Member status updated successfully!");
      } else {
        toast.error("Failed to update member status.");
      }
      return response.data;
    } catch (error) {
      toast.error("Something went wrong while toggling member status.");
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const fetchAllMembers = createAsyncThunk(
  "member/fetchAllMembers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/DynamicInHouseAccounts/arfgdfhfghfghhfhhfhgfhfh`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const fetchOldAllMember = createAsyncThunk(
  "member/fetchOldAllMember",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/DynamicInHouseAccounts/arfgdfhfghfghhfhhfhgfhf`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


export const UpdateOldAllMember = createAsyncThunk(
  "member/UpdateOldAllMember",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/DynamicInHouseAccounts/sdgdfgfd54575674sddfs/${id}`,
        data
      );
      if (response?.data.status === "Customer updated") {
        toast.success("Member updated successfully!");
      } else {
        toast.error("Failed to update member. Please try again.");
      }
      return response.data;
    } catch (error) {
      toast.error("Something went wrong while updating member.");
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const MemberDataActiveFun = createAsyncThunk(
  "member/fetchActiveMembers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/DynamicInHouseAccounts/arfgdfhfghfghhfhhfhgfhgg`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// --- Slice ---

const AddMember = createSlice({
  name: "member",
  initialState: {
    MemberData: null,
    memberLoading: false,
    memberError: null,

    MemberOldAllData: null,
    MemberOldAllLoading: null,
    MemberOldAllError: null,

    ActiveUsersData: null,
    activeUserLoading: false,
    activeUserError: null,

    updateStatus: "idle",
    updateError: null,

    updateOldMemberStatus: "idle",
    updateOldMemberError: null,


    toggleStatus: "idle",
    toggleError: null,

    addStatus: "idle",
    addError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Add Member
      .addCase(NewAddMember.pending, (state) => {
        state.addStatus = "loading";
        state.addError = null;
      })
      .addCase(NewAddMember.fulfilled, (state, action) => {
        state.addStatus = "succeeded";
        state.MemberData = action.payload;
      })
      .addCase(NewAddMember.rejected, (state, action) => {
        state.addStatus = "failed";
        state.addError = action.payload;
      })

      // Update Member
      .addCase(UpdateMember.pending, (state) => {
        state.updateStatus = "loading";
        state.updateError = null;
      })
      .addCase(UpdateMember.fulfilled, (state, action) => {
        state.updateStatus = "succeeded";
        state.MemberData = action.payload;
      })
      .addCase(UpdateMember.rejected, (state, action) => {
        state.updateStatus = "failed";
        state.updateError = action.payload;
      })

      // Toggle Member Status
      .addCase(toggleMemberStatus.pending, (state) => {
        state.toggleStatus = "loading";
        state.toggleError = null;
      })
      .addCase(toggleMemberStatus.fulfilled, (state, action) => {
        state.toggleStatus = "succeeded";
        state.MemberData = action.payload;
      })
      .addCase(toggleMemberStatus.rejected, (state, action) => {
        state.toggleStatus = "failed";
        state.toggleError = action.payload;
      })

      // Fetch All Members
      .addCase(fetchAllMembers.pending, (state) => {
        state.memberLoading = true;
        state.memberError = null;
      })
      .addCase(fetchAllMembers.fulfilled, (state, action) => {
        state.memberLoading = false;
        state.MemberData = action.payload;
      })
      .addCase(fetchAllMembers.rejected, (state, action) => {
        state.memberLoading = false;
        state.memberError = action.payload;
      })

      // Fetch All Old Members
      .addCase(fetchOldAllMember.pending, (state) => {
        state.MemberOldAllLoading = true;
        state.MemberOldAllError = null;
      })
      .addCase(fetchOldAllMember.fulfilled, (state, action) => {
        state.MemberOldAllLoading = false;
        state.MemberOldAllData = action.payload;
      })
      .addCase(fetchOldAllMember.rejected, (state, action) => {
        state.MemberOldAllLoading = false;
        state.MemberOldAllError = action.payload;
      })

      // Update Member
      .addCase(UpdateOldAllMember.pending, (state) => {
        state.updateOldMemberStatus = "loading";
        state.updateOldMemberError = null;
      })
      .addCase(UpdateOldAllMember.fulfilled, (state, action) => {
        state.updateOldMemberStatus = "succeeded";
        state.MemberData = action.payload;
      })
      .addCase(UpdateOldAllMember.rejected, (state, action) => {
        state.updateOldMemberStatus = "failed";
        state.updateOldMemberError = action.payload;
      })

      // Fetch Active Members
      .addCase(MemberDataActiveFun.pending, (state) => {
        state.activeUserLoading = true;
        state.activeUserError = null;
      })
      .addCase(MemberDataActiveFun.fulfilled, (state, action) => {
        state.activeUserLoading = false;
        state.ActiveUsersData = action.payload;
      })
      .addCase(MemberDataActiveFun.rejected, (state, action) => {
        state.activeUserLoading = false;
        state.activeUserError = action.payload;
      });
  },
});

export default AddMember.reducer;
